export default __webpack_public_path__ + "static/media/user-img.ed36819a.png";